import { Component } from '@angular/core';

@Component({
    selector: 'app-concierge-protekta',
    templateUrl: './concierge-protekta.component.html',
    styleUrls: ['./concierge-protekta.component.scss'],
    standalone: false,
})
export class ConciergeProtektaComponent {
    phoneDisplay = '+41 31 389 85 00';
    phoneNr = this.phoneDisplay.split(' ').join('');
}
